import Action  from './baseActions';

// Types

export enum CodeBlockActionTypes {
  UPLOAD_CSV = 'code_block/upload_csv',
  UPLOAD_CSV_LOADING = 'code_block/upload_csv_loading',
  UPLOAD_CSV_SUCCESS = 'code_block/upload_csv_success',
  UPLOAD_CSV_FAILED = 'code_block/upload_csv_failed',
  UPLOAD_CSV_PROGRESS = 'code_block/upload_csv_progress',
}

// Interfaces

export interface IUploadCsvAction extends Action {
  type: CodeBlockActionTypes.UPLOAD_CSV;
  payload: {
    blockUid: string;
    workspaceId: string;
    startTime: string;
    file: File;
  }
}

export interface IUploadingCsvAction extends Action {
  type: CodeBlockActionTypes.UPLOAD_CSV_LOADING;
  payload: {
    blockUid: string;
  };
}

export interface IUploadCsvSuccessAction extends Action {
  type: CodeBlockActionTypes.UPLOAD_CSV_SUCCESS;
  payload: {
    blockUid: string;
    result: any;
  };
}

export interface IUploadCsvFailedAction extends Action {
  type: CodeBlockActionTypes.UPLOAD_CSV_FAILED;
  payload: {
    blockUid: string;
    error: any;
  };
}

export interface IUploadCsvProgressAction extends Action {
  type: CodeBlockActionTypes.UPLOAD_CSV_PROGRESS;
  payload: {
    blockUid: string;
    progress: number;
  };
}

// Functions

export function uploadCsv(blockUid: string, workspaceId: string, startTime: string, file: File): IUploadCsvAction {
  return {
    type: CodeBlockActionTypes.UPLOAD_CSV,
    payload: {
      blockUid,
      workspaceId,
      startTime,
      file,
    }
  };
}

export function uploadingCsv(blockUid: string): IUploadingCsvAction {
  return {
    type: CodeBlockActionTypes.UPLOAD_CSV_LOADING,
    payload: { blockUid },
  };
}

export function uploadCsvSuccess(blockUid: string, result: any): IUploadCsvSuccessAction {
  return {
    type: CodeBlockActionTypes.UPLOAD_CSV_SUCCESS,
    payload: { blockUid, result },
  };
}

export function uploadCsvFailed(blockUid: string, error: any): IUploadCsvFailedAction {
  return {
    type: CodeBlockActionTypes.UPLOAD_CSV_FAILED,
    payload: { blockUid, error },
  };
}

export function uploadCsvProgress(blockUid: string, progress: number): IUploadCsvProgressAction {
  return {
    type: CodeBlockActionTypes.UPLOAD_CSV_PROGRESS,
    payload: {
      blockUid,
      progress,
    }
  };
}

export type CodeBlockActions =
  | IUploadCsvAction
  | IUploadingCsvAction
  | IUploadCsvSuccessAction
  | IUploadCsvFailedAction
  | IUploadCsvProgressAction;
